"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioAccordionGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var RadioAccordion_1 = require("./RadioAccordion");
var RadioAccordionGroup = function (_a) {
    var selectedIdx = _a.selectedIdx, setSelectedIdx = _a.setSelectedIdx, items = _a.items, _b = _a.showButton, showButton = _b === void 0 ? true : _b, _c = _a.fullWidth, fullWidth = _c === void 0 ? true : _c;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-w-full squid-px-4" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "squid-gap-3 squid-flex squid-flex-col" }, { children: items.map(function (item, idx) {
                var label = item.label, helpText = item.helpText, icon = item.icon, disabled = item.disabled, dropdown = item.dropdown;
                return ((0, jsx_runtime_1.jsx)(RadioAccordion_1.RadioAccordion, { index: idx, label: label, fullWidth: fullWidth, helpText: helpText, selectedIdx: selectedIdx, setSelectedIdx: setSelectedIdx, disabled: disabled, showButton: showButton, icon: icon, dropdown: dropdown }, "".concat(label, "-").concat(idx)));
            }) })) })));
};
exports.RadioAccordionGroup = RadioAccordionGroup;
